import { TranslationsContext } from '@teliaee/telia-translate';
import { Card, CardContent, GridColumn, Heading, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../../stores/RoamingStore';
import PackageOrderingModal from './PackageOrderingModal';

interface WeekPackageProps {
  roamingStore?: RoamingStore;
}

@observer
class WeekPackage extends React.Component<WeekPackageProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    const { roamingStore } = this.props;
    const weekPackage = roamingStore.getPackageByShortName('WEEK');
    if (!weekPackage) {
      return null;
    }
    return (
      <GridColumn width={['md-12', 'lg-4']}>
        <Card background="neutral-bg-level-3">
          <CardContent>
            <Text className="text-left">
              <Heading element="h4" className="h3">
                {translate(`roaming.country.package.name.${weekPackage.serviceShortName}`)}
              </Heading>
              <p>{translate('roaming.country.package.volume')}</p>
              <p className="text__margin-none h2">{translate(`roaming.country.package.volume.${weekPackage.volume}`)}</p>
              <p className="text__margin-double">{translate('roaming.country.package.price')}</p>
              <p className="text__margin-none text-bold h4">
                {roamingStore.getPackagePrice(weekPackage)} {translate('roaming.package.price.currency')}
              </p>
              <PackageOrderingModal roamingPackage={weekPackage} />
            </Text>
          </CardContent>
        </Card>
      </GridColumn>
    );
  }
}

export default inject('roamingStore')(WeekPackage);
